import type { TypedUseSelectorHook } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import user from './user/user';
import { authSlice } from './auth/auth';
import getOrder from './payment/getOrder';
import settings from './settings/settings';
import getOrders from './payment/getOrders';
import afterOrder from './payment/afterOrder';
import userMutation from './user/userMutation';
import createOrder from './payment/createOrder';
import userMessages from './messages/user_messages';
import like_activities from './like/like_activities';
import getUserPayment from './payment/getUserPayment';
import userForOrganizer from './user/userForOrganizer';
import anonymous_cities from './cities/anonymous_cities';
import parent_activity from './activity/parent_activity';
import updateUserPayment from './payment/updateUserPayment';
import userRateBlog from './user_rateListing/user_rateBlog';
import userCreateMessage from './messages/user_createMessage';
import parent_activities from './activities/parent_activities';
import anonymous_activity from './activity/anonymous_activity';
import anonymous_activityBlog from './blog/anonymous_activityBlog';
import user_userNotifications from './notifications/notifications';
import userRatingListing from './user_rateListing/user_rateListing';
import selectedConversation from './messages/selected_conversation';
import anonymous_activities from './activities/anonymous_activities';
import anonymous_activityBlogs from './blogs/anonymous_activityBlogs';
import parentReservations from './parent_reservations/parent_reservations';
import userActivityConversations from './messages/user_activityConversations';
import parent_createFreeReservation from './payment/parent_createFreeReservation';
import user_readUserNotification from './notifications/user_readUserNotification';
import parent_listingWithActivityList from './activitiesAndBlogs/parent_listingWithActivityList';
import anonymous_listingWithActivityList from './activitiesAndBlogs/anonymous_listingWithActivityList';
import parent_listingListWithActivityAndBlogList from './activitiesAndBlogs/parent_listingListWithActivityAndBlogList';
import anonymous_listingListWithActivitiesAndBlogList from './activitiesAndBlogs/anonymous_listingListWithActivitiesAndBlogList';

const store = configureStore({
  reducer: {
    auth: authSlice,

    settings,

    user,
    userForOrganizer,

    userMutation,

    //notifications
    user_userNotifications,
    user_readUserNotification,

    //rating
    userRatingListing,
    userRateBlog,

    //messages
    userActivityConversations,
    userCreateMessage,
    userMessages,
    selectedConversation,

    //activity
    parent_activity,
    anonymous_activity,

    //activities
    parent_activities,
    anonymous_activities,
    like_activities,
    parentReservations,
    anonymous_listingListWithActivitiesAndBlogList,
    parent_listingListWithActivityAndBlogList,
    parent_listingWithActivityList,
    anonymous_listingWithActivityList,

    //activityBlog
    anonymous_activityBlog,

    //activityBlogs
    anonymous_activityBlogs,

    //citites
    anonymous_cities,

    //payment
    getUserPayment,
    updateUserPayment,
    createOrder,
    getOrder,
    getOrders,
    afterOrder,
    parent_createFreeReservation,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
